module.exports = __webpack_public_path__ + "static/media/winwin-9.jpeg";